import { Spin } from "antd";
import React, { useRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useConfigContext } from "../../../../context/ConfigContext";

const ReportPrintingHtmlEditor = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam, IsDraftParam, selectedTestIDsParam, IsNDTParam } =
    useParams();
  const iframeRef = useRef(null);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const config = useConfigContext();

  useEffect(() => {
    setIsLoading(true);

    // const API_URL = process.env.REACT_APP_API_BASEURL;
    // const API_URL = config?.API_BASE_URL; // use config.json
    let API_URL;

    const currentHost = window.location.hostname;
    if (
      currentHost === "localhost" ||
      currentHost === "127.0.0.1" ||
      currentHost === "::1" ||
      currentHost.startsWith("192.168.") ||
      currentHost.startsWith("10.") ||
      currentHost.startsWith("172.")
    ) {
      API_URL = config?.API_BASE_URL_LOCAL_NETWORK; // Local API
    } else {
      API_URL = config?.API_BASE_URL;
    }

    if (window.atob(IsNDTParam) == true || window.atob(IsNDTParam) == "true") {
      iframeRef.current.src = `${API_URL}/ReportPrint/NDTReport?inwardMaterial=${PrimaryIdParam}&company=${window.btoa(
        AuthUser?.CompanyIDEncrypt
      )}&branch=${window.btoa(
        AuthUser?.BranchIDEncrypt
      )}&d=${IsDraftParam}&createdby=${window.btoa(
        AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
      )}&tests=${selectedTestIDsParam}`;
    } else {
      iframeRef.current.src = `${API_URL}/ReportPrint/Index?inwardMaterial=${PrimaryIdParam}&company=${window.btoa(
        AuthUser?.CompanyIDEncrypt
      )}&branch=${window.btoa(
        AuthUser?.BranchIDEncrypt
      )}&d=${IsDraftParam}&createdby=${window.btoa(
        AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
      )}&tests=${selectedTestIDsParam}`;
    }
    // setTimeout(() => {
    //   setIsLoading(false);
    // }, 2000);
  }, []);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <div>
      <Spin
        size="large"
        spinning={isLoading}
        tip={"Loading..."}
        style={{ position: "fixed" }}
      >
        <iframe
          ref={iframeRef}
          title="Web View"
          width="100%"
          style={{ height: "100vh" }}
          src="" // Replace with the URL you want to display
          frameBorder="0"
          onLoad={handleIframeLoad} // Add onLoad event handler here
        />
      </Spin>
    </div>
  );
};

export default ReportPrintingHtmlEditor;
